import axios from 'axios'
import router from '../router/index'
import jwtDecode from 'jwt-decode'
import i18n from '../i18n'
export default {
    state: {
        jwt: sessionStorage.getItem('jwt') || null
    },
    getters: {
        role: (state) => {
            if(!state.jwt) return;
            return jwtDecode(state.jwt).roles[0]
        }
    },
    mutations: {
        setJwt(state, val) {
            state.jwt = val
        }
    },
    actions: {
        login({ commit }, credentials) {
            commit('setLoading', true)
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.VUE_APP_BASE_URL}/auth/json`, credentials, { skipAuthRefresh: true })
                    .then(res => {

                        axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`
                        sessionStorage.setItem('jwt', res.data.token)
                        commit('setJwt', res.data.token)
                        sessionStorage.setItem('refreshToken', res.data.refreshToken)
                        commit('setLoading', false)

                        sessionStorage.setItem('userName', credentials.username)
                        

                        const role = jwtDecode(res.data.token).roles[0]
                        console.log(role)
                        if (role == 'front') {
                            router.push('/frontDesk/dashboard')
                            if(sessionStorage.getItem('userName') == 'bioiatrikiFront'){
                                i18n.locale = 'el'
                            }
                        } else if (role == 'company') {
                            router.push('/company/dashboard')
                        } else if (role == 'self') {
                            router.push('/selfService/dashboard')
                        }else if ( role == 'admin'){
                            router.push('/admin/dashboard')
                        }
                        resolve(res)
                    })
                    .catch(err => {
                        commit('setLoading', false)
                        reject(err)
                    })
            })
        },

        logout({ commit }) {
            commit('setJwt', null)
            sessionStorage.removeItem('jwt')
            sessionStorage.removeItem('refreshToken')
            sessionStorage.removeItem('case')
            delete axios.defaults.headers.common['Authorization']
            router.push('/auth/login')
        },

        refreshToken({ commit, dispatch }) {
            axios.get(`${process.env.VUE_APP_BASE_URL}/auth/refresh`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('refreshToken')}`
                }
            })
                .then(res => {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`
                    sessionStorage.setItem('jwt', res.data.token)
                    commit('setJwt', res.data.token)
                    sessionStorage.setItem('refreshToken', res.data.refreshToken)
                })
                .catch(err => {
                    dispatch('logout')
                    console.log(err)
                })
        }
    }
}